import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const useTokenExpiration = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    // Si no hay token, redirigir inmediatamente
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    try {
      const { exp } = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      const handleSessionExpired = () => {
        sessionStorage.removeItem("token");

        Swal.fire({
          icon: "warning",
          title: "Su sesión ha expirado",
          text: "Por motivos de seguridad, debe iniciar sesión nuevamente.",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#3085d6",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          // 👉 Limpia historial para que no pueda regresar atrás
          navigate("/login", { replace: true });
          window.history.pushState(null, "", "/login");
        });
      };

      if (exp < currentTime) {
        handleSessionExpired();
      } else {
        const timeout = (exp - currentTime) * 1000;
        const timer = setTimeout(() => {
          handleSessionExpired();
        }, timeout);
        return () => clearTimeout(timer);
      }
    } catch (error) {
      console.error("Error al decodificar el token:", error);
      sessionStorage.removeItem("token");
      Swal.fire({
        icon: "error",
        title: "Error de sesión",
        text: "Ocurrió un problema con su sesión. Por favor, inicie sesión nuevamente.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        navigate("/login", { replace: true });
        window.history.pushState(null, "", "/login");
      });
    }
  }, [navigate]);
};

export default useTokenExpiration;
